var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 1.04018L4 11.9286H9.14286L7.87683 18.8887C7.87442 18.9024 7.87504 18.9164 7.87863 18.9298C7.88223 18.9432 7.88872 18.9556 7.89765 18.9662C7.90657 18.9768 7.91772 18.9854 7.9303 18.9912C7.94287 18.997 7.95658 19 7.97045 19V19C7.9852 19 7.99975 18.9965 8.01293 18.9899C8.02611 18.9833 8.03757 18.9737 8.04638 18.9618L16.8571 8.07143H11.7143L12.9863 1.11049C12.988 1.09662 12.9868 1.08255 12.9826 1.06921C12.9785 1.05586 12.9715 1.04356 12.9623 1.03311C12.953 1.02265 12.9416 1.0143 12.9289 1.00859C12.9161 1.00288 12.9023 0.999952 12.8883 1V1C12.873 1.00006 12.8579 1.00373 12.8443 1.01071C12.8307 1.01769 12.8189 1.02779 12.81 1.04018V1.04018Z",
    stroke: "#001A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.ddee4b88.svg";
export { ForwardRef as ReactComponent };